import type { QnaFeedView } from "@buildpy/core/views/g5a/qna";

import QnaFeed from "@/modules/process-standard/ui/qna-feed";
import StandardsShell from "@/modules/process-standard/ui/standards-shell";

// Q&A 피드 — 주제별(#390).
const Page = ({ data }: { data: QnaFeedView }) => (
  <StandardsShell tab="qna">
    <QnaFeed data={data} />
  </StandardsShell>
);

export default Page;
